import type { ReactNode } from 'react';
import { cx } from '../utils';
import { ChatIcon, ChevronDownIcon } from './icons';

interface LauncherProps {
  open: boolean;
  label: string;
  avatar?: string | ReactNode;
  onClick: () => void;
}

export function Launcher({ open, label, avatar, onClick }: LauncherProps) {
  const content =
    typeof avatar === 'string' ? (
      <img className="cbw-launcher__img" src={avatar} alt="" />
    ) : (
      avatar ?? <ChatIcon width={26} height={26} />
    );

  return (
    <button
      type="button"
      className={cx('cbw-launcher', open && 'is-open')}
      onClick={onClick}
      aria-label={label}
      aria-expanded={open}
      title={label}
    >
      <span className="cbw-launcher__face cbw-launcher__face--idle">{content}</span>
      <span className="cbw-launcher__face cbw-launcher__face--open">
        <ChevronDownIcon width={24} height={24} />
      </span>
    </button>
  );
}
